module.exports = '4.13.3';



// WEBPACK FOOTER //
// ./src/version.js